import React from 'react';

import { MetaNoIndex } from 'components/shared/MetaNoIndex';
import useUnsavedChangesHistoryBlocker from 'hooks/pages/useUnsavedChangesHistoryBlocker';
import { useAppUpdate } from 'hooks/useAppUpdate';

import useFontAwesome from '../../../integrations/fontawesome/useFontAwesome';
import GuestPortalRootRoutes from './Routes';

function GuestPortal() {
  useUnsavedChangesHistoryBlocker();
  useAppUpdate();
  useFontAwesome();

  return (
    <>
      <MetaNoIndex />
      <GuestPortalRootRoutes />
    </>
  );
}

export default GuestPortal;
